import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Blogbred from '../../Global/Blogbred';
import Teamdetail from '../Mainbloggrid/Teamdetail';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';

const Main = () => {
    return (
        <>
        {/* <Preloader/> */}
            <Headertwo />
            <Blogbred title="Brand Vision" />
            <Teamdetail/>
            {/* <Ctaone/> */}
            <Footer/>
            <BackToTop/>
        </>
    )
}
export default Main;